﻿<script setup>
    const props = defineProps({
        name: String,
        label: String,
        icon: String,
        disabled: Boolean,
        visible: Boolean,
        count: Number
    })

    const tabsCtl = inject('tabsCtl');
    const tab = tabsCtl.value.tabs.find(t => t.name == props.name);

    if (!tab) {
        tabsCtl.value.tabs.push({
            name: props.name,
            label: props.label,
            icon: props.icon,
            disabled: props.disabled,
            count: props.count
        });

        if (!tabsCtl.value.tab) {
            tabsCtl.value.tab = props.name;
        }
    }
</script>

<template>
    <div v-show="tabsCtl.tab == name" p-3>
        <slot></slot>
    </div>
</template>